import {FirebaseUtil, RunConfigService} from '@nuskin/ns-util';
import {UserService} from '@nuskin/ns-account';

const AssessmentService = function() {

    const NOT_LOGGED_IN = {notLoggedIn: true};
    const FAILED_ASSESSMENT_ADD = {error: "Failed to add assessment"};
    const FAILED_ASSESSMENT_DELETE = {error: "Failed to delete assessment"};

    let user;
    let fbLoggedIn = false;

    // ==================================
    // PUBLIC FUNCTIONS
    // ==================================

    return {
        initialize: initialize,
        initializeWithEid: initializeWithEid,
        getAssessments: getAssessments,
        addAssessment: addAssessment,
        deleteAssessment: deleteAssessment
    };

    function initialize(username, password) {
        FirebaseUtil.init(RunConfigService.getEnvironmentCode());
        FirebaseUtil.getSignInToken(username, password)
            .then(authorizeFireBase)
            .catch(err => console.error(err));
    }

    function initializeWithEid() {
        _refreshConfig();

        return new Promise(function(resolve, reject) {
            if (!fbLoggedIn) {
                if (!user) {
                    reject({error: true, reason: 'Not logged in'})
                }

                FirebaseUtil.init(RunConfigService.getEnvironmentCode());
                FirebaseUtil.getSignInTokenWithEid(user.eid)
                    .then((data) => {
                        authorizeFireBase(data)
                            .then((data) => {
                                resolve(data);
                            })
                            .catch((data) => {
                                reject(data);
                            });
                    })
                    .catch(err => {
                        reject({error: true, reason: err});
                    });
            } else {
                resolve();
            }
        });
    }

    function authorizeFireBase(_data) {
        let data = _data;

        return new Promise(function(resolve, reject) {
            let fb = FirebaseUtil.getFB(),
                unsubscribe;

            fb.auth().signInWithCustomToken(data.token)
                .catch(err => {
                    console.error(err);
                    reject({error: true, reason: err})
                });
            unsubscribe = fb.auth().onAuthStateChanged((user) => {
                if (user) {
                    fbLoggedIn = true;
                    unsubscribe();
                    resolve(data);
                }
            });
        });
    }

    function getAssessments(successCallback, failureCallback) {
        const result = {};
        _refreshConfig();
        if (user) {
            FirebaseUtil.init(RunConfigService.getEnvironmentCode());
            FirebaseUtil.getFB().database().ref('/agelocMe/' + user.id).once('value', function (snapshot) {
                let data = snapshot.exportVal();
                if (data) {
                    result.assessments = Object.keys(data).map((key) => {
                        data[key].id = key;
                        return data[key];
                    });
                } else {
                    result.assessments = [];
                }
                successCallback(result);
            }, function () {
                failureCallback({
                    noAssessments: true
                });
            });
        } else {
            failureCallback({noAssessments: true});
        }
    }

    function addAssessment(assessment, successCallback, failureCallback) {
        _refreshConfig();
        if (fbLoggedIn) {
            _addAssessment(assessment, successCallback, failureCallback);
        } else {
            if (user) {
                initializeWithEid()
                    .then(() => {
                        _addAssessment(assessment, successCallback, failureCallback);
                    })
                    .catch((result) => {
                        console.error(result);
                        failureCallback(FAILED_ASSESSMENT_ADD);
                    });
            } else {
                failureCallback(NOT_LOGGED_IN);
            }
        }
    }

    function deleteAssessment(assessmentId, successCallback, failureCallback) {
        _refreshConfig();
        if (fbLoggedIn) {
            _deleteAssessment(assessmentId, successCallback, failureCallback);
        } else {
            if (user) {
                initializeWithEid()
                    .then(() => {
                        _deleteAssessment(assessmentId, successCallback, failureCallback);
                    })
                    .catch((result) => {
                        console.error(result);
                        failureCallback(FAILED_ASSESSMENT_DELETE);
                    });
            } else {
                failureCallback(NOT_LOGGED_IN);
            }
        }
    }

    // ==================================
    // PRIVATE FUNCTIONS
    // ==================================

    function _refreshConfig() {
        user = UserService.getUser();
    }

    function _addAssessment(assessment, successCallback, failureCallback) {
        _refreshConfig();
        FirebaseUtil.getFB().database().ref('/agelocMe/' + user.id).push(assessment).then((result) => {
            successCallback({fbKey: result.key});
        }).catch(() => {
            failureCallback(FAILED_ASSESSMENT_ADD);
        });
    }

    function _deleteAssessment(assessmentId, successCallback, failureCallback) {
        _refreshConfig();
        FirebaseUtil.getFB().database().ref('/agelocMe/' + user.id + '/' + assessmentId).remove().then(() => {
            successCallback();
        }).catch((err) => {
            console.error('Error deleting assessment.', err);
            failureCallback(FAILED_ASSESSMENT_DELETE);
        });
    }
}();

export default AssessmentService;
